import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Select, DatePicker } from 'antd';

const { RangePicker } = DatePicker;
const { Option } = Select;

class SelectDateAndInterval extends Component {

    constructor(props) {
        super(props);
        this.store = props.store;
    }

    onChangeRangePicker = (dates) => {
        this.store.updateSelectedDate(dates);
    }

    onChangeInterval = (value) => {
        console.log(value);
        this.store.updateSelectedInterval(value);
    }

    render() {
        return (
            <div>
                <Select defaultValue="5d" style={{ width:120}} onChange = {this.onChangeInterval} >
                    <Option value="5d">5d</Option>
                    <Option value="10d">10d</Option>
                    <Option value="1mo">1mo</Option>
                </Select>
                <RangePicker onChange={this.onChangeRangePicker}/>
            </div>
        )
    }
}

export default observer(SelectDateAndInterval)
